import { useQuery } from '@tanstack/react-query';
import { attributeService } from '@/services/attribute.service';
import type { FilterableAttribute } from '@/services/queryKeys';

export function useFilterableAttributes() {
  return useQuery<FilterableAttribute[]>({
    queryKey: ['attributes', 'filterable'],
    queryFn: () => attributeService.getFilterable(),
    staleTime: 10 * 60 * 1000,
  });
}
